import { render, staticRenderFns } from "./AddAdminModal.vue?vue&type=template&id=e77c22a2&scoped=true&"
import script from "./AddAdminModal.vue?vue&type=script&lang=js&"
export * from "./AddAdminModal.vue?vue&type=script&lang=js&"
import style0 from "./AddAdminModal.vue?vue&type=style&index=0&id=e77c22a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77c22a2",
  null
  
)

export default component.exports